import { useMemo } from 'react';
import { useStore } from '@/store/useStore';

/**
 * Сдвиг показа времени (в миллисекундах) по выбранному в часах поясу — относительно
 * системного. Прибавляется к «сырой» метке времени ПЕРЕД показом (и перед определением
 * даты/часа), чтобы во всём проекте время и дата отображались в выбранном поясе.
 */
export function useTzShiftMs(): number {
  const clockTz = useStore((s) => s.clockTz);
  const filterBranchId = useStore((s) => s.filterBranchId);
  const branches = useStore((s) => s.branches);
  return useMemo(() => {
    const systemOff = -new Date().getTimezoneOffset();
    const selBranch = filterBranchId !== 'all' ? branches.find((b) => b.id === filterBranchId) : null;
    const displayOff = clockTz.kind === 'offset' ? clockTz.min
      : clockTz.kind === 'branch' ? (selBranch?.tz_offset_minutes ?? systemOff)
      : systemOff;
    return (displayOff - systemOff) * 60_000;
  }, [clockTz, filterBranchId, branches]);
}
